import { Component, OnInit, Input, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'div.smitem',
  templateUrl: './dn-submenu.component.html',
  styleUrls: ['../dn-menu.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class DnSubmenuComponent implements OnInit {
  // isAdult = environment.cinema === 2;

  @Input()
  submenu = [];

  constructor() { }

  ngOnInit() {
  }

  @HostBinding('class') size = this.submenu.length>30?"three-col":"";

}
